import React, {useEffect, useState} from 'react';
import {View, Text, Platform} from 'react-native';
import SettingsBar from './SettingsBar';
import styled from 'styled-components/native';
import Bugsnag from "@bugsnag/expo";
import {
    WorkoutContainerHeaderTwo,
    WorkoutContainerHeaderThree,
    WorkoutContainerText,
    WorkoutTextHeader,
    WorkoutCommonButton,
    WorkoutCommonButtonTwo,
    WorkoutButtonTwo,
    WorkoutTextSubHeader,
} from '../styles/common-styles';
import {useDispatch, useSelector} from "react-redux";
import * as SecureStore from "expo-secure-store";
import * as Config from "../../app.json"
import {clearState} from "../reducers/cbcAuthorizationSlice";

function CbcSettings(props) {
    const cbcWorkout = useSelector((state) => state.cbcWorkout);
    const dispatch = useDispatch();
    const cbcAuthorization = useSelector((state) => state.cbcAuthorization)
    const activityScores = useSelector((state) => state.activityScores)
    const reminderActions = useSelector((state) => state.reminderActions);
    const [username, setUsername] = useState('');

    const getUser = async () => {
        await SecureStore.getItemAsync('username').then((e)=>{
            setUsername(e);
        });
    }

    useEffect(() => {
        getUser();
    }, []);

    const submitLogs = () => {
        Bugsnag.notify(`
                Auth Store:
                ${JSON.stringify(cbcAuthorization)}
                ----------------------
                Workout Store:
                ${JSON.stringify(cbcWorkout)}
                ----------------------
                Activity Scores Store:
                ${JSON.stringify(activityScores)}
                ----------------------
                Reminder Messages Store:
                ${JSON.stringify(reminderActions)}                
                `
        )

        alert('Debug Information sent to Developers');
    }

    return (
        <SettingsParent>
            <AccountSecurityContainer>
                <WorkoutTextSubHeader style={{marginBottom: 7.5}}>
                    MY ACCOUNT
                </WorkoutTextSubHeader>
                <WorkoutTextHeader style={{marginTop:0}}>Username</WorkoutTextHeader>
                <WorkoutContainerText>{username}</WorkoutContainerText>
                <WorkoutTextHeader style={{marginTop:15}}>Account Security</WorkoutTextHeader>
                <WorkoutCommonButtonTwo style={{marginTop: 15, maxWidth: 195}}>
                    <WorkoutContainerHeaderThree
                        onPress={() => {
                            props.navigation.navigate('resetpassword', {
                                callbackFunction: null,
                                invokedFromSettings: 1,
                            });
                        }}
                        style={{color: '#c04c97', fontSize: 14}}
                    >
                        RESET PASSWORD
                    </WorkoutContainerHeaderThree>
                </WorkoutCommonButtonTwo>
            </AccountSecurityContainer>

            <AccountSecurityContainer style={{marginTop:15}}>
                <WorkoutTextSubHeader style={{marginBottom: 7.5}}>
                    REMINDERS
                </WorkoutTextSubHeader>
                <WorkoutTextHeader style={{marginTop:0}}>Reminder Settings</WorkoutTextHeader>
                <WorkoutCommonButtonTwo style={{marginTop: 15, maxWidth: 195}}>
                    <WorkoutContainerHeaderThree
                        onPress={() => {
                            props.navigation.navigate('remindermanager', {
                                callbackFunction: null,
                                invokedFromSettings: 1,
                            });
                        }}
                        style={{color: '#c04c97', fontSize: 14}}
                    >
                        MANAGE REMINDERS
                    </WorkoutContainerHeaderThree>
                </WorkoutCommonButtonTwo>
            </AccountSecurityContainer>
            {Platform.OS !== 'web' && <SettingsBar navigation={props.navigation}/>}
            <DebugLink onPress={() => submitLogs()}>
                <DebugLinkText>Send Debug Info</DebugLinkText>
            </DebugLink>
{/* 
            <DebugLink onPress={() => dispatch(clearState())} style={{marginBottom:25}}>
                <DebugLinkText>Clear State</DebugLinkText>
            </DebugLink> */}

            <VersionNumberContainer>
                <VersionNumber>{Config.expo.version}</VersionNumber>
            </VersionNumberContainer>
        </SettingsParent>
    );
}

export const SettingsParent = styled.View`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #ffffff;
  padding: 15px;
`;

export const AccountSecurityContainer = styled.View`
  width: 100%;
  max-width: 450px;
  padding: 20px;
  /*min-height:300px;*/
  background: #fefaf8;
`;

export const DebugLink = styled.TouchableHighlight`
  position: absolute;
  bottom: 20px;
  right: 20px;
`
export const DebugLinkText = styled.Text`
  color: lightgray;
  font-size: 8px;
`

export const VersionNumberContainer = styled.View`
  width:100%;
  height:20px;
  position: absolute;
  bottom:0;
  left:15px;
  right:0;
  display: flex;
  justify-content: center;
  align-items: center; 
`

export const VersionNumber = styled.Text`
  color:black;
  font-size:12px;
`

export default CbcSettings;
